// src/utils/serverUtils.ts

const KEY = 'currentServer';

/**
 * The world the player picked, or null if they have not picked one this browser.
 *
 * Distinct from `getCurrentServer` on purpose. That one falls back to beta so the hundred
 * call sites reading it never have to handle null, which is right for them and wrong for
 * routing: with world selection now its own page, "no world chosen" has to be a state the
 * app can recognise, or every fresh login would be silently dropped into beta.
 */
export const getSelectedServer = (): string | null => localStorage.getItem(KEY);

export const getCurrentServer = (): string => {
    // Just get what's stored, no validation needed
    return localStorage.getItem(KEY) || 'beta';
};

export const setCurrentServer = (serverId: string): void => {
    localStorage.setItem(KEY, serverId);
};

export const getServerSpecificId = (userId: string, serverId?: string): string => {
    const server = serverId || getCurrentServer();

    // Beta server uses original ID (no suffix for backwards compatibility)
    if (server === 'beta') {
        return userId;
    }

    // Other servers use suffix
    return `${userId}_${server}`;
};
